import {useMemo} from 'react'
import {getRandomId} from 'utils/generalUtils'

export default function useId() {
  return useMemo(() => getRandomId(), [])
}
